import type { APMAsset } from '@cognite/apm-client';
import type { Asset } from '@cognite/sdk';

export const convertAPMAssetToAsset = (apmAsset: APMAsset): Asset => ({
  ...apmAsset,
  name: apmAsset.name ?? '',
  rootId: apmAsset.rootId,
  labels: [],
  id: apmAsset.id ?? NaN,
  lastUpdatedTime: new Date(apmAsset.lastUpdatedTime ?? 0),
  createdTime: new Date(apmAsset.createdTime ?? 0),
});
